import '.././App.css';

function Footer () {
  return (
    <div className="footer">
    </div>
  );
}

export default Footer;